import { Link } from "react-router-dom"

const NavBar =()=>{
  return(
    <div className="nav-div">
      <nav className="nav-bar">
        <Link to='/'>Home</Link>
        <Link to='/Projects'>Projects</Link>
        <Link to='contact-info'>Contact Info</Link>
      </nav>
    </div>
  )
}

export default NavBar